// Feature flags for Browser Key Isolation rollout
// Default to browser-based AI on, with conservative provider toggles for direct-from-browser usage

export const useBrowserAI = true;

// Providers that may have stricter CORS or usage guidance — keep disabled initially
export const enableOpenAIBrowser = true;

// App metadata for providers that accept client attribution headers
export const appTitle = 'QuillGen';

// Debugging: when true, client will log prompt render inputs/outputs
export const DEBUG_AI = false;
